let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i8qCQ")).then(() => parcelRequire('jefpy'));